import { AsyncButton } from '@components/AsyncButton'
import { Box, Button, Divider, Modal, Typography } from '@mui/material'

import * as S from './styles'

interface IProps {
	isModalOpened: boolean
	title: string
	subtitle?: string
	confirmText?: string
	onConfirm: () => Promise<void>
	cancelText?: string
	onCancel: () => void
}

const ConfirmationModal = ({
	isModalOpened,
	onConfirm,
	confirmText,
	onCancel,
	cancelText,
	title,
	subtitle,
}: IProps) => (
	<Modal open={isModalOpened} onClose={onCancel}>
		<S.BackdropWithModalStyles>
			<Typography variant="h2">{title}</Typography>
			<Box pb={4} pt={1}>
				<Divider />
			</Box>

			<Typography
				variant="subtitle2"
				component="h5"
				color="textSecondary"
				style={{ marginBottom: '20px' }}
			>
				{subtitle}
			</Typography>

			<div className="add-product-modal-action-part">
				<Button
					className="add-product-modal-cancel-button"
					variant="outlined"
					color="primary"
					data-testid="cancel"
					onClick={onCancel}
				>
					{cancelText}
				</Button>
				<AsyncButton
					variant="contained"
					color="primary"
					data-testid="submit"
					onClick={onConfirm}
				>
					{confirmText}
				</AsyncButton>
			</div>
		</S.BackdropWithModalStyles>
	</Modal>
)

export { ConfirmationModal }
